export default __webpack_public_path__ + "static/media/cara-kerja-3.6a5d4b33.png";